var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"info-box"},[_c('span',{staticClass:"info-box-icon bg-info"},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.data))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }